const ChatStateEnum = {};

ChatStateEnum.REQUESTING = { value: 0, name: 'Requesting' };
ChatStateEnum.CONNECTED = { value: 1, name: 'Connected' };
ChatStateEnum.ENDED = { value: 2, name: 'Ended' };

ChatStateEnum.fromValue = value => {
  switch (value) {
    case 0:
      return ChatStateEnum.REQUESTING;
    case 1:
      return ChatStateEnum.CONNECTED;
    case 2:
      return ChatStateEnum.ENDED;
    default:
      return {};
  }
};
export default ChatStateEnum;
